import IconButton, {
	IconButtonProps,
} from 'src/components/primitives/IconButton/IconButton';
import { SetRequired } from 'type-fest';

type Props = Omit<SetRequired<IconButtonProps, 'icon'>, 'children' | 'size'>;

export default function TopBarIconButton({ icon: Icon, ...props }: Props) {
	return <IconButton size="md" variant="secondary" icon={Icon} {...props} />;
}
